import React, { createContext, useContext } from 'react'
import { useSetupStatus } from '@/hooks/useSetupStatus'

/**
 * Instancia compartida de useSetupStatus para componentes bajo AppLayout.
 *
 * Consumidores (ConfiguracionInicialCard, páginas piloto) leen el mismo estado y
 * pueden llamar invalidate() para que el panel actualice el check verde en
 * tiempo real después de una acción exitosa.
 *
 * IMPORTANTE: OnboardingGuard y OnboardingWizard quedan en el raw hook
 * porque se renderizan fuera del árbol cubierto por este provider.
 */
type SetupStatusContextValue = ReturnType<typeof useSetupStatus>

const SetupStatusContext = createContext<SetupStatusContextValue | null>(null)

export function SetupStatusProvider({ children }: { children: React.ReactNode }) {
  const value = useSetupStatus()
  return <SetupStatusContext.Provider value={value}>{children}</SetupStatusContext.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSetupStatusContext() {
  const ctx = useContext(SetupStatusContext)
  if (!ctx) throw new Error('useSetupStatusContext must be used within SetupStatusProvider')
  return ctx
}
